import React from 'react';
import Box from '@material-ui/core/Box';
import {makeStyles, withStyles} from '@material-ui/core';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import Avatar from "@material-ui/core/Avatar/Avatar";
import clsx from "clsx";
import {defaultVariabls} from "../../../../config";
import {Link} from "react-router-dom";
import Button from "@material-ui/core/Button/Button";
import ArrowRightAltRoundedIcon from '@material-ui/icons/ArrowRightAltRounded';
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Title from "../../../components/elements/Title";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import Hidden from "@material-ui/core/Hidden/Hidden";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .user-info': {
            width: '100%',
        },
    },
    pointer: {
        cursor: 'pointer',
    },
    profilePic: {
        height: 40,
        width: 40,
        fontSize: 24,
        [theme.breakpoints.up('xl')]: {
            height: 45,
            width: 45,
        },
    },
    userInfo: {
        width: 'calc(100% - 75px)',
    },
    userName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 13,
        fontWeight: 700,
        marginBottom: 2,
    },
    adminRoot: {
        color:"#fff",
        fontSize: 14,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    avatarRoot: {
        position: 'relative',
    },
    userStatus: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        zIndex: 1,
        width: 14,
        height: 14,
        borderRadius: '50%',
        border: `1px solid white`,
        [theme.breakpoints.up('xl')]: {
            width: 16,
            height: 16,
        },
    },
}));

const Header = ({
                    selectedUser,
                    deleteConversation,
                    locale,
                    loading,
                    contact,
                    manage,
                    department,
                    type,
                    order_item,
                    user,
                    history
}) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box pr={2} pl={2} width={1} display='flex' alignItems='center' className={classes.root}>
            <Box display='flex' alignItems='center'>
                <Box className={clsx(classes.userInfo, 'user-info')}>
                    <Box display='flex' alignItems='center' justifyContent='space-between'>
                        <Button
                            className={clsx(classes.userName)}
                            onClick={handleClickOpen}
                            size="small"
                            startIcon={
                                <Avatar
                                    className={classes.profilePic}
                                    src={!loading ? `${defaultVariabls.uploads}/FileManager/${contact.avatar.name}_small.${contact.avatar.extension}` : null}
                                />
                            }
                        >
                            {
                                !loading ?
                                    <Typography style={{display:'flex',flexDirection:"column",alignItems: "flex-start"}}>
                                        {
                                            type === "system" ?
                                                <span>{contact.first_name+" "+contact.last_name}</span>
                                            :
                                                <span>{order_item.shop.name}</span>

                                        }
                                        {
                                            type === "system" ?
                                                <span style={{fontSize:11}}>{" ("+Translate.department+" "+department.name+") "}</span>
                                                :
                                                <span style={{fontSize:11}}>{" ("+Translate.product+" "+order_item.product.name+") "}</span>

                                        }
                                    </Typography>
                                    : null
                            }
                        </Button>
                    </Box>
                </Box>
            </Box>
            <Box ml='auto' display='flex' alignItems='center'>
                <Box ml={2} component='span' color='text.disabled'>
                    <Hidden mdDown>
                        <Button
                            component={Link}
                            to={manage ? "/manage/tickets" : "/tickets"}
                            size="small"
                            variant="outlined"
                            startIcon={<ArrowRightAltRoundedIcon />}
                        >
                            {Translate.backToTickets}
                        </Button>
                    </Hidden>
                    <Hidden mdUp>
                        <Tooltip title={Translate.backToTickets}>
                        <IconButton
                            component={Link}
                            to={manage ? "/manage-tickets" : "/tickets"}
                            size="small"
                        >
                            <ArrowRightAltRoundedIcon />
                        </IconButton>
                        </Tooltip>
                    </Hidden>
                </Box>
            </Box>
            <Dialog
                maxWidth="xs"
                fullWidth
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>
                    <IconButton style={{position: "absolute",top: 0,left:0}} onClick={handleClose}>
                        <CloseRoundedIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {
                        !loading ?
                            <DialogContentText>
                                <Grid container spacing={2} alignItems="center" justify="center">
                                    <Grid item xs={12} style={{textAlign:"center"}}>
                                        <Avatar
                                            style={{textAlign:"center",width:120,height:120,transform:"translateX(-50%)",position:"absolute",left:"50%"}}
                                            src={!loading ? `${defaultVariabls.uploads}/FileManager/${contact.avatar.name}_small.${contact.avatar.extension}` : null}
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{marginTop:120}}>
                                        <Title>
                                            {contact.first_name+" "+contact.last_name}
                                            {
                                                type === "system" ?
                                                    <Typography>({Translate[contact.role.name]})</Typography>
                                                :
                                                    <Typography>({order_item.shop.name})</Typography>

                                            }
                                        </Title>
                                    </Grid>

                                    <Grid item xs={12}>
                                        {
                                            type === "system" ?
                                                <Title>
                                                    <Typography>({Translate.department} {department.name})</Typography>
                                                </Title>
                                                :
                                                <Title>
                                                    <Typography>({Translate.product} {order_item.product.name})</Typography>
                                                </Title>
                                        }

                                    </Grid>
                                    {
                                        user.role.type=== "admin" &&
                                            <>
                                            <Grid item xs={12}>
                                                <Typography align="center">
                                                    <a href={`tel:${contact.mobile}`}>
                                                        {contact.mobile}
                                                    </a>
                                                </Typography>
                                            </Grid>
                                                <Grid item xs={12}>
                                                    <Typography align="center">
                                                        <a href={`mailto:${contact.email}`}>
                                                            {contact.email}
                                                        </a>
                                                    </Typography>
                                                </Grid>
                                        </>
                                    }


                                </Grid>
                            </DialogContentText>
                            : null
                    }

                </DialogContent>
            </Dialog>
        </Box>
    );
};

const mstp = state => ({
    Translate: state.Translate,
    locale: state.locale,
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Header))));